import React from 'react';
import { StyledCenterBox } from '../Home.styled';
import { Button, Typography } from '@mui/material';
import HomeSection from '../HomeSection';
import useSelectedFavourites from '../../../zustand/SelectedFavourites';
import Overview from '../../overviewandfilter/overview/Overview';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';

const FavouriteSection: React.FC = () => {
  const { selectedCompetitions, selectedTeams } = useSelectedFavourites();
  return (
    <>
      <HomeSection
        buttonTitle={'Edit'}
        title={
          <>
            {' '}
            <FavoriteRoundedIcon color="primary" /> Your favourite teams and
            competitions
          </>
        }
        linkTo="/favouriteselection"
        content={
          <>
            {selectedCompetitions.length === 0 && selectedTeams.length === 0 ? (
              <StyledCenterBox>
                <Typography variant="subtitle2">
                  No favourites selected
                </Typography>{' '}
                <br />
                <a href="/favouriteselection">
                  <Button variant="outlined" color="secondary">
                    Go to favourite selection
                  </Button>
                </a>
              </StyledCenterBox>
            ) : (
              <Overview />
            )}
          </>
        }
      />
    </>
  );
};
export default FavouriteSection;
